import {Point} from './point';


export class Beacon {
    
    _id?: string;
    uuid: string;
    firm: string;
    status: number;
    name: string;
    location: Point;

    public setID(id) {
        this._id = id;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/beacon.ts